import { render } from "./create-account.vue?vue&type=template&id=a5121c9e"
import script from "./create-account.vue?vue&type=script&lang=js"
export * from "./create-account.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__